import { AcaRuleContext } from '@adw/projects/aca-shared/rules/src/app.rules';

export function canEnrich(context: AcaRuleContext): boolean {
  if (!context.selection.isEmpty) {
    const nodes = context.selection.nodes;
    return nodes.some((node) => {
      const isFolder = node.entry.isFolder;
      if (
        isFolder &&
        node.entry.aspectNames?.indexOf('enr:enrichmentAllowed') !== -1
      ) {
        return true;
      }

      const isNotWorkingCopy =
        node.entry.isFile &&
        -1 === node.entry.aspectNames?.indexOf('cm:workingcopy');
      const enrichObject = context.appConfig.get('enrichmentJobs');
      const enrichableTypes = Array.isArray(enrichObject)
        ? enrichObject.map((obj) => obj.type)
        : [];
      return (
        isNotWorkingCopy && enrichableTypes.indexOf(node.entry.nodeType) > -1
      );
    });
  }

  return false;
}
